import React from 'react';

import UploadCard from 'components/Card/UploadCard';
import CardLayout from 'components/CardLayout/CardLayout';
import ResponsiveContainer from 'components/ResponsiveContainer';
import { supportedFilesDetails } from 'components/WrappedComponents/Uploader/constants';
import Uploader from 'components/WrappedComponents/Uploader/Uploader';
import { useImportAlienationContournement } from 'hooks/alienation/useImportContournementCsv';
import { SupportedFile } from 'types/enums/SupportedFile';

const Import = (): React.ReactElement => {
  const [importCsv, status] = useImportAlienationContournement();
  const { fileTypes } = supportedFilesDetails[SupportedFile.CSV];

  return (
    <ResponsiveContainer>
      <h1>{`Import des refus / impossibilité de vente`} </h1>
      <p>
        {`Vous pouvez depuis cette page importer les refus ou impossibilités
        de vendre un véhicule. Pour cela, il vous suffit de cliquer sur 
        l'élément 'Retours de la DNID' et de choisir le fichier contenant ces 
        véhicules. Ce fichier doit être au format CSV.`}
      </p>
      <CardLayout>
        <UploadCard status={status}>
          <Uploader
            importRoute={importCsv}
            title={'Retours de la DNID'}
            fileTypes={fileTypes}
          />
        </UploadCard>
      </CardLayout>
    </ResponsiveContainer>
  );
};

export default Import;
